import { isRecord } from "@atlassiansox/bxp-shared-utils";

export type UnpublishedEntry = {
    sys: {
        type: "Link";
        linkType: "Entry";
        id: string;
    };
};

export function isUnpublishedEntry(model: unknown): model is UnpublishedEntry {
    if (!isRecord(model)) {
        return false;
    }

    return (
        isRecord((model as UnpublishedEntry).sys) &&
        (model as UnpublishedEntry).sys.type === "Link" &&
        (model as UnpublishedEntry).sys.linkType === "Entry" &&
        typeof (model as UnpublishedEntry).sys.id === "string"
    );
}

export type UnpublishedAsset = {
    sys: {
        type: "Link";
        linkType: "Asset";
        id: string;
    };
};

export function isUnpublishedAsset(model: unknown): model is UnpublishedAsset {
    if (!isRecord(model)) {
        return false;
    }

    return (
        isRecord((model as UnpublishedAsset).sys) &&
        (model as UnpublishedAsset).sys.type === "Link" &&
        (model as UnpublishedAsset).sys.linkType === "Asset" &&
        typeof (model as UnpublishedAsset).sys.id === "string"
    );
}
